'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mockStore;

var _configureStore = require('./configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mockStore(reducer) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var acts = [];

  var onAction = function onAction(act) {
    acts.push(act);
  };
  var actionCatchMiddleware = function actionCatchMiddleware() {
    return function (next) {
      return function (action) {
        onAction(action);
        next(action);
      };
    };
  };

  // place action catch middleware at the end

  for (var _len = arguments.length, middlewares = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    middlewares[_key - 2] = arguments[_key];
  }

  middlewares.push(actionCatchMiddleware);
  var store = _configureStore2.default.apply(undefined, [reducer, initialState].concat(middlewares));

  // Additional store helper methods
  // getActions return current collected actions
  store.getActions = function () {
    return acts;
  };

  // setActions overwrites collected actions
  store.setActions = function (newActs) {
    acts = newActs;
  };

  // clearActions resets existing actions
  store.clearActions = function () {
    acts = [];
  };

  return store;
}